import { FC } from "react";

import { IconButton, Link, Stack, TooltipHost, useTheme } from "@bps/fluent-ui";
import { AppointmentStartingPoints } from "@libs/analytics/app-insights/app-insights.enums.ts";
import { CalendarEventType } from "@libs/gateways/booking/BookingGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { Contact } from "@stores/practice/models/Contact.ts";

import { getPatientSearchBoxStyles } from "./PatientAppointmentsSearch.styles.ts";

interface PatientAppointmentItemFooterProps {
  patient: Contact;
  onAddEventClick: (patientId: string) => void;
  onDismissCallout: () => void;
  setShowEditAppointmentModal: (value: string) => void;
}
export const PatientAppointmentItemFooter: FC<
  PatientAppointmentItemFooterProps
> = ({
  patient,
  onAddEventClick,
  onDismissCallout,
  setShowEditAppointmentModal
}) => {
  const { booking } = useStores();
  const theme = useTheme();
  const {
    appointmentFooterStyles,
    lastAndNextApptTextStyles,
    newApptIconStyles
  } = getPatientSearchBoxStyles(theme);

  const patientId = patient.id;

  const handleOnCreateNewAppointmentClick = () => {
    booking.ui.showCalendarEventDialog(
      {
        type: CalendarEventType.Appointment,
        initialValues: { patientId }
      },
      AppointmentStartingPoints.PatientSearchAddAppointmentButton
    );
    onAddEventClick(patientId);
  };

  const handleOnLastApptClick = () => {
    onDismissCallout();
    setShowEditAppointmentModal(patientId);
    onAddEventClick(patientId);
  };

  return (
    <Stack
      horizontal
      verticalAlign="center"
      horizontalAlign="end"
      tokens={{ childrenGap: 32 }}
      styles={appointmentFooterStyles}
      className="suggestionContainer__footer"
    >
      <Link styles={lastAndNextApptTextStyles} onClick={handleOnLastApptClick}>
        All appointments
      </Link>
      <TooltipHost content="New appointment">
        <IconButton
          styles={newApptIconStyles}
          iconProps={{ iconName: "AddEvent" }}
          onClick={handleOnCreateNewAppointmentClick}
        />
      </TooltipHost>
    </Stack>
  );
};
